import couponTypes from './types';
export const initialStates = {
	list: {},
	item: {},
	invalidate: {},
};
export default function couponReducers(state = initialStates, action) {
	switch (action.type) {
		case couponTypes.GET_COUPON.SUCCESS: {
			return {
				...state,
				list: { ...action.payload?.data },
			};
		}
		case couponTypes.INVALIDATE_COUPON.SUCCESS: {
			return {
				...state,
				invalidate: { ...action.payload },
			};
		}
		case couponTypes.GET_COUPON.CLEAR: {
			return {
				...state,
				list: {},
			};
		}
		default:
			return state;
	}
}
